import styles from './form.module.scss';
import TextareaAutosize from 'react-textarea-autosize';
import { useDropzone } from 'react-dropzone';
import { useState, useCallback } from 'react';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useTranslation } from 'next-i18next';
import * as Sentry from "@sentry/nextjs";

const Form = ({ vacancy = null }) => {
  const [errors, setErrors] = useState(false);
  const [success, setSuccess] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const { t } = useTranslation(['common', 'vacancy']);

  const onSubmit = async data => {
    setErrors(false);
    setSuccess(false);
    // console.log(data, myFiles);
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append('vacancy', vacancy);

    myFiles.map((file, k) => {
      formData.append(`file`, file);
    });

    try {
      const res = await axios.post('/v1/api/vacancies/feed-back/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.status === 201) {
        resetForm();
        setSuccess(true);
      }
    } catch (error) {
      Sentry.captureException(error);
      setErrors(true);
    }
  };

  const [myFiles, setMyFiles] = useState([]);

  const onDrop = useCallback(
    acceptedFiles => {
      setMyFiles([...myFiles, ...acceptedFiles]);
    },
    [myFiles]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  const removeAll = () => {
    setMyFiles([]);
  };

  const removeFile = file => () => {
    const newFiles = [...myFiles];
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
  };

  const resetForm = () => {
    reset({ name: '', phone: '', email: '', text: '', vacancy });
    removeAll();
  };

  const files = myFiles.map(file => (
    <li key={file.path}>
      {file.path}{' '}
      <button className={styles.removeButton} onClick={removeFile(file)}>
        &times;
      </button>
    </li>
  ));

  return (
    <form className={styles.wrapper} onSubmit={handleSubmit(onSubmit)}>
      {errors && (
        <div className={clsx(styles.formLine, styles.formLineErrors)}>
          {t(
            'Произошла ошибка при отправке формы. Пожалуйста, проверьте правильно ли Вы заполнили все поля.'
          )}
        </div>
      )}
      {success && (
        <div className={clsx(styles.formLine, styles.formLineSuccess)}>
          {t('Заявка успешно отправлена.')}
        </div>
      )}
      <div className={styles.formLine}>
        <input
          type="text"
          placeholder={t('ФИО')}
          {...register('name', { required: true, maxLength: 256 })}
        />
      </div>
      <div className={styles.formLine}>
        <input
          type="text"
          placeholder={t('Телефон (+7 999 99-99-99)')}
          {...register('phone', { required: true, maxLength: 256 })}
        />
      </div>
      <div className={styles.formLine}>
        <input
          type="text"
          placeholder={t('E-mail')}
          {...register('email', { required: true, maxLength: 256 })}
        />
      </div>
      <div className={styles.formLine}>
        <TextareaAutosize placeholder={t('Текст обращения')} {...register('text')} />
      </div>
      <div {...getRootProps({ className: styles.dropzone })}>
        <input {...getInputProps()} />
        <p>
          {t(
            'Переместите файлы сюда или щёлкните мышью для их загрузки (PDF или изображения, максимум 5Мб)'
          )}
        </p>
      </div>
      {myFiles.length > 0 && (
        <aside>
          <h3>{t('Файлы')}:</h3>
          <ul>{files}</ul>
        </aside>
      )}

      <div className={styles.actions}>
        <button className={clsx(styles.button, styles.buttonClear)} onClick={resetForm}>
          {t('Сбросить')}
        </button>
        <button type="submit" className={clsx(styles.button, styles.buttonSend)}>
          {t('Отправить')}
        </button>
      </div>
    </form>
  );
};

export default Form;
